// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"b93693fa","350":"a4ae8bd4"}[chunkId] + ".chunk.css";
};